import { useMemo, useState } from "react";

export const useModalState = () => {
  const [open, setOpen] = useState(false);
  const openModal = () => {
    setOpen(true);
  };

  const closeModal = () => {
    setOpen(false);
  };

  return useMemo(
    () => ({
      open,
      openModal,
      closeModal,
    }),
    [open]
  );
};
